import { useEffect, useMemo, useState } from "react"

import { adminApi } from "../axios"
import { buildAnalyticsQueryParams } from "./reportDateRangePresets"

export function useActivityReportAnalytics(dateRange, refreshToken = 0) {
  const [analytics, setAnalytics] = useState(null)
  const [loading, setLoading] = useState(true)
  const rangeKey = useMemo(
    () => `${dateRange?.preset}:${dateRange?.from}:${dateRange?.to}`,
    [dateRange?.from, dateRange?.preset, dateRange?.to]
  )
  const queryParams = useMemo(
    () => buildAnalyticsQueryParams(dateRange),
    [rangeKey, dateRange]
  )

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    adminApi
      .fetchReportAnalytics(queryParams)
      .then(({ data }) => {
        if (!cancelled) {
          setAnalytics(data)
        }
      })
      .catch(() => {
        if (!cancelled) {
          setAnalytics(null)
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false)
        }
      })
    return () => {
      cancelled = true
    }
  }, [queryParams, rangeKey, refreshToken])

  return { analytics, loading }
}
